import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "src/app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { CluNumpadDialogComponent } from "./clu-numpad-dialog.component";
import { CluNumpadDialogService } from "./clu-numpad-dialog.service";
import { TablerIconsModule } from "angular-tabler-icons";
import { FormsModule } from "@angular/forms";

@NgModule({
    declarations: [CluNumpadDialogComponent],
    imports: [
        CommonModule,
        TranslateModule,
        MaterialModule,
        TablerIconsModule,
        FormsModule,
    ],
    providers: [CluNumpadDialogService]
})
export class CluNumpadDialogModule {}